module.exports = __webpack_public_path__ + "static/img/cosmic.630839a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/anniversary/cosmic.png
// module id = hIYT
// module chunks = 0